<template>
  <v-container>
    <!-- What is EASI -->
    <v-container class="whatIsEasiBox">
      <h1>{{ $t("what_is_easi") }}</h1>
      <v-row>
        <v-col cols="12" lg="8">
          <v-card class="whatIsEasiCard">
            <ul>
              <li>{{ $t("easi_def") }}</li>
              <li>
                {{ $t("easi_def_text") }}
              </li>
              <li>
                {{ $t("easi_def_text1") }}
              </li>
            </ul>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- How to count EASI -->
    <v-container>
      <h1>{{ $t("how_to_count_EASI") }}</h1>
      <v-row justify="center">
        <v-col lg="4" md="4" cols="12">
          <v-card class="howToCountCard">
            <div>
              <div class="numberCircle">1</div>
              <div class="howToCountHeader">{{ $t("choose_part_title") }}</div>
              <div class="howToCountContent">
                <p>
                  {{ $t("choose_part_text") }}
                </p>
                <br />
                <p>
                  <strong> {{ $t("four_parts") }}</strong>
                </p>
                <ul>
                  <li>{{ $t("head") }}</li>
                  <li>{{ $t("upper_limbs") }}</li>
                  <li>{{ $t("trunk") }}</li>
                  <li>{{ $t("lower_limbs") }}</li>
                </ul>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col lg="4" md="4" cols="12">
          <v-card class="howToCountCard">
            <div>
              <div class="numberCircle">2</div>
              <div class="howToCountHeader">
                {{ $t("record_range_disability") }}
              </div>
              <div class="howToCountContent">
                <p>{{ $t("range_disability_text") }}</p>
                <br />
                <table>
                  <th>{{ $t("region_score") }}</th>
                  <th>{{ $t("region_percentage") }}</th>
                  <tr>
                    <td>0</td>
                    <td>0%</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>1 – 9%</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>10 – 29%</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>30 – 49%</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>50 – 69%</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>70 – 89%</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>90 – 100%</td>
                  </tr>
                </table>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col lg="4" md="4" cols="12">
          <v-card class="howToCountCard">
            <div>
              <div class="numberCircle">3</div>
              <div class="howToCountHeader">
                {{ $t("gravity_disability") }}
              </div>
              <div class="howToCountContent">
                <p>
                  {{ $t("gravity_disability_text") }}
                </p>
                <br />
                <p>
                  <strong>{{ $t("symptoms_are") }}</strong>
                </p>
                <ul>
                  <li>{{ $t("erytem") }}</li>
                  <li>{{ $t("papules") }}</li>
                  <li>{{ $t("excoriation") }}</li>
                  <li>{{ $t("lichenification") }}</li>
                </ul>
                <br />
                <p>
                  {{ $t("the_severity_evaluation") }}
                  <br />{{ $t("scale") }}
                </p>
                <table>
                  <th>{{ $t("severity_score") }}</th>
                  <th>{{ $t("severity") }}</th>
                  <tr>
                    <td>0</td>
                    <td>{{ $t("none") }}</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>{{ $t("moderate") }}</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>{{ $t("medium") }}</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>{{ $t("severe") }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="reference">
      {{ $t("reference") }}:
      <div class="reference-link">
        <a
          href="https://www.sciencedirect.com/science/article/abs/pii/S0926995998952916?via%3Dihub"
          target="_blank"
        >
          Tofte SJ, Graeber M, Cherill R et al. Eczema area and severity index
          (EASI): A new tool to evaluate atopic dermatitis. J Eur Acad Dermatol
          Venereol 1998; 11:S197.</a
        >
      </div>
      <div class="reference-link">
        <a
          href="https://onlinelibrary.wiley.com/doi/abs/10.1034/j.1600-0625.2001.100102.x?sid=nlm%3Apubmed"
          target="_blank"
        >
          Hanifin JM, Thurston M, Omoto M et al. The Eczema Area and Severity
          Index (EASI): assessment of reliability in atopic dermatitis. EASI
          Evaluator Group. Exp Dermatol 2001; 10:11–18.
        </a>
      </div>
      <div class="reference-link">
        <a
          href="https://onlinelibrary.wiley.com/doi/abs/10.1111/bjd.13662"
          target="_blank"
        >
          Leshem YA, Hajar T, Hanifin JM et al. What the Eczema Area and
          Severity Index score tells us about the severity of atopic dermatitis:
          an interpretability study. Br J Dermatol. 2015;172(5):1353-7
        </a>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    language: "Čeština",
    czech: null
  }),
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    clickToScroll(el, pos) {
      let element = document.querySelector(el);
      element.scrollIntoView({
        behavior: "smooth",
        block: pos,
        inline: "nearest"
      });
      document.getElementById(el).scrollTop += 100;
    },
    onLocaleChange() {
      this.$i18n.locale = this.$i18n.locale === "cs" ? "sk" : "cs";
      this.language = this.czech === true ? "Čeština" : "Slovenština";
    }
  }
};
</script>
<style scoped lang="scss">
ul {
  padding: 0;
  list-style-type: none;
  li {
    margin-bottom: 10px;
  }
}
table {
  margin: auto;
  border-collapse: collapse;
  td {
    width: 10em;
    border: 1px solid gainsboro;
  }
}
.v-card {
  box-shadow: 0px 0px 18px 0px rgba(209, 209, 209, 1);
}
.whatIsEasiCard {
  margin-bottom: 5em;
  padding: 2em;
}
.howToCountCard {
  padding: 2em;
  height: 100%;
}
h1 {
  color: gray;
  margin-bottom: 0.2em;
}
.numberCircle {
  font-size: 1.2em;
  display: flex;
  border: 5px solid rgb(216, 142, 5);
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  text-align: center;
  width: 3em;
  height: 3em;
  margin: auto;
}
.howToCountHeader {
  margin: 2em 0;
  text-align: center;
  font-size: 1.2em;
  padding-bottom: 1em;
  border-bottom: 1px solid gainsboro;
}
.howToCountContent {
  text-align: center;
  margin: 0 2em;
}
//Menu styles
.fas {
  margin-right: 1em;
  color: #324c8d;
}
.v-list-item__title.mennuHeader {
  padding: 5px 0;
  font-size: 1em;
  color: #324c8d;
}
.v-toolbar__title {
  a {
    color: white;
    text-decoration: none;
  }
}

.reference {
  margin-top: 3rem;

  .reference-link {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
}

@media screen and (max-width: 900px) {
  .reference {
    padding: 1rem;
  }
}

@media only screen and (min-width: 200px) and (max-width: 425px) {
  .howToCountCard {
    height: auto;
    padding: 2em 0em;
  }
  .container {
    padding: 16px 5px;
  }
  h1 {
    text-align: center;
  }
}
</style>
